import { useContext } from "react";

import { Context } from "../../context";
import { resetStyle } from "../../utils/styles";
import { getArticle, getComments, getHome } from "../../utils/api";
import { setComments } from "../../redux/comments";
import { makeArticleShema } from "../../lib/schemas";

import CommonHead from "../../components/CommonHead";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import ArticleHeader from "../../components/ArticleHeader";
import ArticleContent from "../../components/ArticleContent";

const Article = ({ article, home }) => {
  const url = `https://www.appcheeta.com/article/${article.slug}`;

  return (
    <>
      <CommonHead>
        <title>{`${article.title} - AppCheeta`}</title>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(makeArticleShema({ article, url })) }}
        />
        
      </CommonHead>
      <style jsx>{resetStyle}</style>
      <style jsx>
        {`
          .sticky {
            position: sticky;
            top: 2rem;
          }
        `}
      </style>
      <Navbar />
      <div className="page">
        <ArticleHeader article={article} />
        <ArticleContent article={article} top={home} />
      </div>
      <Footer />
      <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2933500308486888"
          crossOrigin="anonymous"
        ></script>
    </>
  );
};

Article.getInitialProps = async ({ query, store, cached, res }) => {
  const { slug } = query;
  const entity_type = "article";
  try {
    const { article } = await getArticle({ slug, cached });
    const { home } = await getHome({ cached });
    const { comments } = await getComments({ entity_slug: slug, entity_type, cached });
    store.dispatch(setComments({ comments, entity_type, entity_slug: slug }));
    const analytics = {
      content_group1: "Article", // Page Type
    };
    return { article, home, analytics };
  } catch (error) {
    if (error.statusCode === 404) {
      console.error(`Article ${slug} ${error.statusCode}`);
      res.statusCode = 404;
      res.end("Not found");
    } else {
      throw error;
    }
  }
};

export default Article;
